import { postSecureCardViewerMessage } from './postSecureCardViewerMessage';
let queuedToken;
function applySecureCardViewerToken(token) {
    try {
        if (typeof globalThis.swap !== 'function') {
            postSecureCardViewerMessage({ message: 'error', reason: 'bootstrap' });
            return;
        }
        globalThis.swap({ token });
    }
    catch {
        postSecureCardViewerMessage({ message: 'error', reason: 'bootstrap' });
    }
}
export function initSecureCardViewer(token) {
    const trimmedToken = token?.trim();
    if (!trimmedToken) {
        postSecureCardViewerMessage({ message: 'error', reason: 'bootstrap' });
        return;
    }
    if (typeof globalThis.swap !== 'function') {
        queuedToken = trimmedToken;
        return;
    }
    applySecureCardViewerToken(trimmedToken);
}
export function flushQueuedSecureCardViewerToken() {
    if (queuedToken === undefined) {
        return;
    }
    const token = queuedToken;
    queuedToken = undefined;
    applySecureCardViewerToken(token);
}
export function clearQueuedSecureCardViewerToken() {
    queuedToken = undefined;
}
export function exposeSecureCardViewerBootstrap() {
    globalThis.__initSecureCardViewer = initSecureCardViewer;
}
